import React from 'react';
import { Button } from './ui/button';
import { bookingLink } from '../data/mockData';

const AppointmentSection = ({ onCitySelect }) => {
  const handleBookingLink = () => {
    window.open(bookingLink, '_blank');
  };

  return (
    <section id="appointments" className="py-20 bg-neutral-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-serif mb-6">Agenda tu cita</h2>
          <p className="text-lg text-neutral-300 font-light mb-12 max-w-2xl mx-auto leading-relaxed">
            En Morea te atendemos con cita para que puedas probarte vestidos con tranquilidad y recibir asesoría personalizada.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={() => onCitySelect('Quito')}
              className="bg-white text-neutral-900 hover:bg-neutral-100 px-8 py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-xl hover:scale-105 w-full sm:w-auto"
            >
              Agendar cita en Quito
            </Button>
            <Button
              onClick={() => onCitySelect('Guayaquil')}
              className="bg-white text-neutral-900 hover:bg-neutral-100 px-8 py-6 text-lg rounded-sm transition-all duration-300 hover:shadow-xl hover:scale-105 w-full sm:w-auto"
            >
              Agendar cita en Guayaquil
            </Button>
          </div>

          <div className="mt-8">
            <Button
              onClick={handleBookingLink}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-neutral-900 px-8 py-6 text-lg rounded-sm transition-all duration-300 w-full sm:w-auto"
            >
              Ver link de reservas
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentSection;
